import { isAccountPreview } from './previewMode'
import type { MgmtUserProfile } from './profile'

const base = () =>
  (
    import.meta.env.VITE_ACCOUNT_API_URL ||
    // Preview local da conta: o mock instalado em dev intercepta /api/me/*.
    (isAccountPreview ? window.location.origin : '')
  ).replace(/\/$/, '')

function networkError(err: unknown): string {
  const msg = err instanceof Error ? err.message : String(err)
  if (/Failed to fetch|NetworkError|Load failed/i.test(msg)) {
    return `Não conseguimos falar com o serviço da conta (${base() || 'URL não configurada'}). Tente novamente em instantes.`
  }
  return msg
}

export async function fetchMgmtProfile(
  accessToken: string,
): Promise<{ profile?: MgmtUserProfile; error?: string; hint?: string }> {
  if (!base()) {
    return {
      error: 'VITE_ACCOUNT_API_URL não configurada',
      hint: 'Defina VITE_ACCOUNT_API_URL no .env da SPA',
    }
  }
  try {
    const res = await fetch(`${base()}/api/me/profile`, {
      headers: { authorization: `Bearer ${accessToken}` },
    })
    const data = (await res.json()) as MgmtUserProfile & {
      error?: string
      message?: string
      hint?: string
    }
    if (!res.ok || data.error) {
      return {
        error: data.message || data.error || `HTTP ${res.status}`,
        hint: data.hint,
      }
    }
    return { profile: data }
  } catch (err) {
    return { error: networkError(err) }
  }
}

export async function patchUserMetadata(
  accessToken: string,
  user_metadata: Record<string, unknown>,
): Promise<{ profile?: MgmtUserProfile; error?: string; hint?: string }> {
  // O Worker devolve o patch (ou um ack). A tela usa o retorno só quando ele
  // traz `user_metadata`; caso contrário mantém o perfil em memória.
  if (!base()) {
    return { error: 'VITE_ACCOUNT_API_URL não configurada' }
  }
  try {
    const res = await fetch(`${base()}/api/me/profile`, {
      method: 'PATCH',
      headers: {
        authorization: `Bearer ${accessToken}`,
        'content-type': 'application/json',
      },
      body: JSON.stringify({ user_metadata }),
    })
    const data = (await res.json()) as MgmtUserProfile & {
      error?: string
      message?: string
      hint?: string
    }
    if (!res.ok || data.error) {
      return {
        error: data.message || data.error || `HTTP ${res.status}`,
        hint: data.hint,
      }
    }
    return { profile: data }
  } catch (err) {
    return { error: networkError(err) }
  }
}
